import styled from "styled-components";

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 8px;
  margin: 0;
  background: rgba(247, 154, 0, 0.1);
  border: 1px solid #F79A00;
  border-radius: 12px;
`;

export const Title = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #565556;
`;

export const Text = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #565556;
`;

export const DetailsList = styled.ul`
  padding-left: 20px;
  margin: 0;
`;

export const ListItem = styled.li`
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #565556;
`; 